import type { ReactNode } from 'react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets.ts';

const ChoreographerModal = ({ children, onClose }) => {
	const { Modal } = useChoreographerAssets();

	return (
		<Modal onClose={onClose} width={420}>
			{children}
		</Modal>
	);
};

const i18n = defineMessages({
	cancel: {
		id: 'import-from-sources.warning-modal.cancel-btn',
		defaultMessage: 'Cancel',
		description: 'Cancel button text for the warning modal',
	},
	submit: {
		id: 'import-from-sources.warning-modal.submit-btn',
		defaultMessage: 'Select new file',
		description: 'Submit button text for the warning modal',
	},
});

type WarningModalProps = {
	onSubmit: () => void;
	onClose: () => void;
	headText: ReactNode;
	bodyText: ReactNode;
	submitText?: ReactNode;
};

export const WarningModal: React.FC<WarningModalProps> = ({
	onSubmit,
	onClose,
	headText,
	bodyText,
	submitText,
}) => {
	return (
		<ChoreographerModal onClose={onClose}>
			<ModalHeader hasCloseButton>
				<ModalTitle appearance="warning">{headText}</ModalTitle>
			</ModalHeader>
			<ModalBody>{bodyText}</ModalBody>
			<ModalFooter>
				<>
					<Button appearance="subtle" onClick={onClose} testId="warning-modal-cancel-button">
						<FormattedMessage {...i18n.cancel} />
					</Button>
					<Button appearance="primary" onClick={onSubmit} testId="warning-modal-submit-button">
						{submitText || <FormattedMessage {...i18n.submit} />}
					</Button>
				</>
			</ModalFooter>
		</ChoreographerModal>
	);
};
